if (!customElements.get("cart-coupon")) {
  class CartCoupon extends HTMLElement {
    static pending = false;
    static flashAttempt = '';
    static flashEndsAt = Date.parse('2026-10-18T21:59:00Z');
    static expiredFlashNotice = false;
    constructor() {
      super();

      this.button = this.querySelector("button");
      this.input = this.querySelector("input");
      this.status = this.querySelector(".cart-coupon-status");
      this.allowMultiple = this.dataset.multiple === "true";
      this.couponCodes = [];
      this.flashSelected = !!window.waxerCustomerSale;
      try { this.flashSelected ||= sessionStorage.getItem('waxer-flash-code') === 'FLASHSALE20'; } catch (_) {}
      this.expiredFlashReminder = this.flashHasEnded() && (this.flashSelected || CartCoupon.expiredFlashNotice);
      if (this.flashHasEnded()) {
        CartCoupon.expiredFlashNotice ||= this.expiredFlashReminder;
        this.flashSelected = false;
        try { sessionStorage.removeItem('waxer-flash-code'); } catch (_) {}
      }
      if (this.flashSelected) this.input.value = 'FLASHSALE20';
      const customer = document.getElementById('WaxerWelcome');
      if (customer && customer.dataset.returningCustomer !== 'true' && !window.waxerCustomerSale && !this.expiredFlashReminder && !this.input.value) this.input.value = 'WELCOME10';

      // Focus the coupon input when the minicart <details> opens
      this.details = this.querySelector(".mini-cart-coupon-dropdown");
      if (this.details) {
        this.details.addEventListener("toggle", () => {
          if (this.details.open) {
            requestAnimationFrame(() => {
              this.input?.focus();
              this.input?.select();
            });
          }
        });
      }

      this.reconcileCart = async () => {
        const request = this.cartRequest = (this.cartRequest || 0) + 1;
        const response = await this.getCartContents();
        if (!this.isConnected || request !== this.cartRequest || typeof response.original_total_price !== 'number') return;
        this.couponCodes = this.getExistingCouponCodes(response);
        // Replace the previous welcome offer without touching other codes.
        this.couponCodes = this.couponCodes.filter(code => code.code.toUpperCase() !== 'WELCOME20');
        let welcome = false;
        try { welcome = sessionStorage.getItem('waxer-welcome-offer') === '1'; } catch (_) {}
        const welcomeDialog = document.getElementById('WaxerWelcome');
        if (welcomeDialog) welcome = welcomeDialog.dataset.returningCustomer !== 'true';
        if (this.dataset.welcomeEligible !== undefined) welcome = this.dataset.welcomeEligible === 'true';
        if (window.waxerCustomerSale) welcome = false;
        this.cartCurrency = response.currency || 'EUR';
        this.cartOriginal = response.original_total_price;
        const flashInCart = this.couponCodes.some(code => code.code.toUpperCase() === 'FLASHSALE20');
        if (this.flashHasEnded() && flashInCart) this.expiredFlashReminder = true;
        if (!this.flashHasEnded() && ((!this.input.value && (this.flashSelected || flashInCart)) || (window.waxerCustomerSale && this.input.value === 'WELCOME10'))) this.input.value = 'FLASHSALE20';
        this.syncButton();
        if (this.showExpiredFlash()) return;
        if (this.input.value.trim().toUpperCase() === 'FLASHSALE20') {
          this.flashSelected = true;
          try { sessionStorage.setItem('waxer-flash-code', 'FLASHSALE20'); } catch (_) {}
          this.syncButton();
          if (this.showFlashMinimum()) return;
          const applied = this.couponCodes.some(code => code.code.toUpperCase() === 'FLASHSALE20' && code.applicable === true);
          if (applied) this.hideStatusMessage();
          const signature = `${response.original_total_price}:${response.total_price}:${response.item_count}`;
          if (!applied && !CartCoupon.pending && CartCoupon.flashAttempt !== signature) {
            CartCoupon.flashAttempt = signature;
            this.submit(new Event('click'));
          }
          return;
        }
        if (this.couponCodes.length && !this.couponCodes.some(code => code.code.toUpperCase() === 'WELCOME10') && this.input.value === 'WELCOME10') this.input.value = this.couponCodes[0].code;
        if (!this.input.value && this.couponCodes.some(code => code.code.toUpperCase() === 'WELCOME10')) this.input.value = 'WELCOME10';
        const otherCode = this.couponCodes.some(code => code.code.toUpperCase() !== 'WELCOME10');
        const welcomeApplied = this.couponCodes.some(code => code.code.toUpperCase() === 'WELCOME10' && code.applicable === true);
        this.syncButton();
        if (welcome && !otherCode && (!this.input.value || this.input.value === 'WELCOME10')) {
          this.input.value = 'WELCOME10';
          const remaining = Math.max(0, 2500 - response.original_total_price);
          this.welcomeRemaining = remaining;
          if (remaining > 0) this.hideStatusMessage();
          else if (welcomeApplied) this.setStatusMessage(window.waxerT('welcome_applied'), true);
          else if (!CartCoupon.pending) this.submit(new Event('click'));
        }
      };

      this.button.addEventListener("click", this.submit.bind(this));
      this.input.addEventListener("keydown", this.submit.bind(this));
      this.input.addEventListener('input', () => {
        this.syncButton();
        this.hideStatusMessage();
        if (!this.showExpiredFlash()) this.showFlashMinimum();
      });
    }

    connectedCallback() {
      this.onCartChanged = () => this.reconcileCart();
      document.addEventListener('waxer:cart-changed', this.onCartChanged);
      this.reconcileCart();
    }

    disconnectedCallback() {
      document.removeEventListener('waxer:cart-changed', this.onCartChanged);
      this.cartRequest = (this.cartRequest || 0) + 1;
    }

    syncButton() {
      const code = this.input.value.trim().toUpperCase();
      document.documentElement.classList.toggle('waxer-flash-selected', code === 'FLASHSALE20');
      const applied = this.couponCodes.some(discount => discount.code.toUpperCase() === code && discount.applicable === true);
      const expired = code === 'FLASHSALE20' && this.flashHasEnded();
      const label = this.button.querySelector('[data-coupon-button-label]');
      if (label) label.textContent = expired ? window.waxerT('expired') : applied ? window.waxerT('applied') : window.waxerT('apply');
      this.button.classList.toggle('is-applied', applied || expired);
      this.button.disabled = applied || expired;
    }

    flashHasEnded() {
      return Date.now() >= CartCoupon.flashEndsAt;
    }

    showExpiredFlash() {
      const code = this.input.value.trim().toUpperCase();
      if (!this.flashHasEnded() || code !== 'FLASHSALE20') return false;
      CartCoupon.expiredFlashNotice = this.expiredFlashReminder = true;
      CartCoupon.flashAttempt = '';
      this.status.classList.remove('is-minimum-notice');
      this.setStatusMessage(window.waxerT('expired_flash'));
      return true;
    }

    showFlashMinimum() {
      if (this.showExpiredFlash()) return true;
      if (this.input.value.trim().toUpperCase() !== 'FLASHSALE20' || !Number.isFinite(this.cartOriginal) || this.cartCurrency !== 'EUR') return false;
      const remaining = Math.max(0, 5000 - this.cartOriginal);
      if (!remaining) return false;
      CartCoupon.flashAttempt = '';
      const amount = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:'EUR'}).format(remaining / 100);
      this.setStatusMessage(window.waxerT('flash_remaining', {amount}));
      this.status.classList.add('is-minimum-notice');
      return true;
    }

    async submit(event) {
      if (event instanceof KeyboardEvent && event.key !== "Enter") {
        return;
      }

      event.preventDefault();
      if (CartCoupon.pending) return;

      this.hideStatusMessage();
      if (this.showExpiredFlash()) {
        this.syncButton();
        return;
      }

      const couponsEntered = this.input.value
        .split(",")
        .map((coupon) => coupon.trim().toUpperCase())
        .filter((coupon) => coupon && coupon.length > 0);

      // Only grab the first coupon entered.
      const coupon = couponsEntered.shift();
      if (coupon === 'FLASHSALE20') {
        this.flashSelected = true;
        try { sessionStorage.setItem('waxer-flash-code', 'FLASHSALE20'); } catch (_) {}
        if (this.showFlashMinimum()) return;
      }
      if (coupon === 'WELCOME10' && this.welcomeRemaining > 0) return;

      if (!coupon) {
        // Enable these lines and disable the return below to allow clearing all coupons, by simply submitting an empty code.
        // this.couponCodes = [];
        // this.setStatusMessage("Coupons cleared!", true);

        return false;
      }

      const alreadyApplied = (couponCode) =>
        this.couponCodes.reduce((applied, discount) => {
          return applied || discount.code.toUpperCase() === couponCode;
        }, false);

      const couponAppliesToCart = (couponCode) =>
        this.couponCodes.reduce((applied, discount) => {
          return (
            applied || (discount.code.toUpperCase() === couponCode && discount.applicable === true)
          );
        }, false);

      if (coupon && alreadyApplied(coupon) && couponAppliesToCart(coupon)) {
        this.setStatusMessage(coupon === 'WELCOME10' ? window.waxerT('welcome_included') : cartStrings.couponAlreadyApplied, true);
        return false;
      }

      if (!this.allowMultiple) {
        this.couponCodes = [];
      }

      const newCouponCodes = [coupon, ...this.couponCodes.map((discount) => discount.code)];
      CartCoupon.pending = true;
      this.setLoading();

      fetch(routes.cart_update_url, {
        ...fetchConfig(),
        ...{
          body: JSON.stringify({
            discount: newCouponCodes.join(","),
            sections: [...new Set(this.getSectionsToRender().map((section) => section.section))],
          }),
        },
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status || response.errors) throw new Error('Discount update failed');
          this.couponCodes = this.getExistingCouponCodes(response);

          if (coupon) {
            if (couponAppliesToCart(coupon)) {
              this.setStatusMessage(cartStrings.couponSuccess, true);
              this.input.value = ['WELCOME10', 'FLASHSALE20'].includes(coupon) ? coupon : '';
            } else {
              this.setStatusMessage(cartStrings.couponNotApplicable, false);
            }
          }

          this.getSectionsToRender().forEach((section) => {
            if (!response.sections?.[section.section]) return;
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) ||
              document.getElementById(section.id);

            const html = this.getSectionInnerHTML(response.sections[section.section], section.selector);
            if (html !== null) elementToReplace.innerHTML = html;
          });
        })
        .catch((error) => {
          console.error("Fetch error:", error);
          this.setStatusMessage(cartStrings.couponError, false);
        })
        .finally(() => {
          CartCoupon.pending = false;
          document.dispatchEvent(new CustomEvent('waxer:cart-changed'));
          this.removeLoading();
        });
    }

    async getCartContents() {
      let json = {};

      try {
        const response = await fetch(routes.cart_url, {
          method: "GET",
          headers: { "Content-Type": "application/json", Accept: `application/json` },
        });

        json = await response.json();
      } catch (error) {
        console.error("Error:", error);
      }

      return json;
    }

    getSectionInnerHTML(html, selector = ".shopify-section") {
      return new DOMParser().parseFromString(html, "text/html").querySelector(selector)?.innerHTML ?? null;
    }

    getSectionsToRender() {
      return [
        {
          id: "cart-page-title-wrap",
          section: document.getElementById("cart-page-title-wrap")?.dataset.id,
          selector: ".page-title-wrap",
        },
        {
          id: "main-cart-items",
          section: document.getElementById("main-cart-items")?.dataset.id,
          selector: ".js-contents",
        },
        {
          id: "header",
          section: document.getElementById("header").dataset.id,
          selector: ".head-slot-cart-link",
        },
        {
          id: "cart-live-region-text",
          section: "cart-live-region-text",
          selector: ".shopify-section",
        },
        {
          id: "main-cart-footer",
          section: document.getElementById("main-cart-footer")?.dataset.id,
          selector: ".js-contents",
        },
        {
          id: "header-mini-cart-content",
          section: "header-mini-cart-content",
        },
        {
          id: "header-mini-cart-footer",
          section: "header-mini-cart-footer",
        },
        {
          id: "mobile-dock",
          section: document.getElementById("mobile-dock")?.dataset.id,
          selector: ".head-slot-cart-link",
        },
      ].filter((section) => {
        const element = document.getElementById(section.id);
        return element && (section.selector ? element.querySelector(section.selector) : true);
      });
    }

    getExistingCouponCodes(response) {
      return response?.discount_codes ?? [];
    }

    hideStatusMessage() {
      this.status.classList.remove('is-minimum-notice');
      this.status.classList.add("hidden");
      this.status.classList.remove(...["form-status-success", "form-status-error"]);
      this.status.innerHTML = "";
    }

    setStatusMessage(message, success = false) {
      this.status.classList.remove(...["hidden", "form-status-success", "form-status-error"]);
      this.status.classList.add(success ? "form-status-success" : "form-status-error");
      this.status.innerHTML = message;
    }

    setLoading() {
      this.button.disabled = true;
      this.button.classList.add("loading");
      this.button.querySelector(".button-overlay-spinner")?.classList.remove("hidden");
    }

    removeLoading() {
      this.syncButton();
      this.button.classList.remove("loading");
      this.button.querySelector(".button-overlay-spinner")?.classList.add("hidden");
    }
  }

  customElements.define("cart-coupon", CartCoupon);
}
